<div class="flex items-center">
  <button
    type="button"
    class="relative inline-flex h-4 w-10 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-black"
    [class.bg-[#55B96E]]="checked"
    [class.bg-gray-200]="!checked"
    role="switch"
    [attr.aria-checked]="checked"
    [attr.aria-labelledby]="id"
    (click)="toggle()"
  >
    <span
      aria-hidden="true"
      class="absolute top-1/2 left-0 transform -translate-x-1/2 -translate-y-1/2 inline-block h-6 w-6 rounded-full border-2 border-solid bg-white shadow-black transition duration-200 ease-in-out"
      [class.translate-x-[75%]]="checked"
      [class.translate-x-[0%]]="!checked"
      [style.borderColor]="checked ? '#14192D' : '#C8C8CD'"
    >
    <svg *ngIf="checked" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block h-3 w-3">
      <path d="M10.375 2.30859L4.125 8.55859L1.625 6.05859" stroke="#14192D" stroke-width="2"/>
    </svg>
  </span>
  </button>
  <span class="ml-3 text-sm" [id]="id">
    <span class="font-medium text-gray-900 text-base">{{ text }}</span>
  </span>
</div>